import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { writeToLocalStorage } from "common/utilities/localStorage";
import type { CallToActionId } from "domains/callsToAction/types";

type CallsToActionState = { dismissed: [CallToActionId, number][] };

const initialState: CallsToActionState = { dismissed: [] };

export const callsToActionSlice = createSlice({
  name: "callsToAction",
  initialState,
  reducers: {
    dismiss: (state, action: PayloadAction<CallToActionId>) => {
      const index = state.dismissed.findIndex(([id]) => id === action.payload);
      const time = new Date().getTime();
      if (index === -1) state.dismissed.push([action.payload, time]);
      else state.dismissed[index][1] = time;
      writeToLocalStorage("dismissedCallsToAction", state.dismissed);
    },
    revive: (state, action: PayloadAction<CallToActionId>) => {
      const index = state.dismissed.findIndex(([id]) => id === action.payload);
      if (index === -1) return;
      state.dismissed.splice(index, 1);
      writeToLocalStorage("dismissedCallsToAction", state.dismissed);
    },
  },
});
